import { render } from "./KubernetesLoggingMonitoring.vue?vue&type=template&id=48b65776"
import script from "./KubernetesLoggingMonitoring.vue?vue&type=script&lang=js"
export * from "./KubernetesLoggingMonitoring.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__